module.exports = __webpack_public_path__ + "static/img/img_about1.da3e565.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_about1.png
// module id = J+xr
// module chunks = 1